import { useRef } from 'react';

// Pure decision function (unit-tested): given the gesture delta, decide direction.
// Horizontal must beat threshold AND dominate vertical movement (so it doesn't
// hijack list scrolling).
export function detectSwipe({ dx, dy, threshold = 50 }) {
  if (Math.abs(dx) < threshold) return null;
  if (Math.abs(dy) > Math.abs(dx)) return null;
  return dx < 0 ? 'next' : 'prev';
}

// Returns pointer handlers; calls onNext/onPrev on a horizontal swipe.
export function useSwipe({ onNext, onPrev, threshold = 50 }) {
  const start = useRef(null);
  return {
    onPointerDown: (e) => { start.current = { x: e.clientX, y: e.clientY }; },
    onPointerUp: (e) => {
      if (!start.current) return;
      const dir = detectSwipe({ dx: e.clientX - start.current.x, dy: e.clientY - start.current.y, threshold });
      start.current = null;
      if (dir === 'next') onNext?.();
      else if (dir === 'prev') onPrev?.();
    },
    onPointerCancel: () => { start.current = null; },
  };
}
